<template>
    <div class="publish-form">
        <div class="head display_flex align-center justify-between" :class="{'ios-head':iosnav}">
            <div class="back" @click="goback">
                <img src="../../../static/images/publish/back.png" alt class="back-icon" />
            </div>
            <div class="heade-title">
                <p class="title">发布需求</p>
            </div>
            <div class="mine" @click="inquiry">
                <img src="../../../static/images/publish/kefu-icon.png" alt class="mine-img" />
            </div>
        </div>
        <div class="form" :class="{'ios-form':iosnav}">
            <div class="form-info">
                <div class="form-item" @click="showPopup('areaType')">
                    <div class="item-tip">目标区域</div>
                    <div class="item-info display_flex justify-between align-center">
                        <input
                            type="text"
                            class="info-box"
                            placeholder="请选择商铺所属商圈"
                            readonly
                            v-model="showOptions.areaName + showOptions.business_area_name.join('/')"
                        />
                        <img src="../../../static/images/publish/go.png" alt class="go" />
                    </div>
                </div>

                <div class="form-item">
                    <div class="item-tip" :class="{'active-color':active == 'rent'}">月租金·元</div>
                    <div class="item-info display_flex justify-between align-center">
                        <div class="maxNum display_flex align-center">
                            <label for>最低</label>
                            <van-field
                                class="rent"
                                v-model="params.monthly_rent_lower"
                                type="number"
                                placeholder="请输入"
                                @focus="focus('rent')"
                                @blur="blur"
                                @input="params.monthly_rent_lower=params.monthly_rent_lower.replace(/\D*(\d*)(\.?)(\d{0,2})\d*/,'$1$2$3')"
                            />
                        </div>
                        <span class="line">/</span>
                        <div class="minNum display_flex align-center">
                            <label for>最高</label>
                            <van-field
                                class="rent"
                                v-model="params.monthly_rent_upper"
                                type="number"
                                placeholder="请输入"
                                @focus="focus('rent')"
                                @blur="blur"
                                @input="params.monthly_rent_upper=params.monthly_rent_upper.replace(/\D*(\d*)(\.?)(\d{0,2})\d*/,'$1$2$3')"
                            />
                        </div>
                    </div>
                </div>
                <div class="form-item">
                    <div class="item-tip" :class="{'active-color':active == 'area'}">面积·㎡</div>
                    <div class="item-info display_flex justify-between align-center">
                        <div class="maxNum display_flex align-center">
                            <label for>最小</label>
                            <van-field
                                class="rent"
                                v-model="params.area_lower"
                                type="number"
                                placeholder="请输入"
                                @focus="focus('area')"
                                @blur="blur"
                                @input="params.area_lower=params.area_lower.replace(/\D*(\d*)(\.?)(\d{0,2})\d*/,'$1$2$3')"
                            />
                        </div>
                        <span class="line">/</span>
                        <div class="minNum display_flex align-center">
                            <label for>最大</label>
                            <van-field
                                class="rent"
                                v-model="params.area_upper"
                                type="number"
                                placeholder="请输入"
                                @focus="focus('area')"
                                @blur="blur"
                                @input="params.area_upper=params.area_upper.replace(/\D*(\d*)(\.?)(\d{0,2})\d*/,'$1$2$3')"
                            />
                        </div>
                    </div>
                </div>
                <div class="form-item" @click="showPopup('type')">
                    <div class="item-tip">商铺类型</div>
                    <div class="item-info display_flex justify-between align-center">
                        <input
                            type="text"
                            class="info-box"
                            placeholder="请选择商铺类型"
                            readonly
                            v-model="showOptions.type_name.join('/')"
                        />
                        <img src="../../../static/images/publish/go.png" alt class="go" />
                    </div>
                </div>
                <div class="form-item" style="border-bottom:none;" @click="showPopup('formatType')">
                    <div class="item-tip">计划经营</div>
                    <div class="item-info display_flex justify-between align-center">
                        <input
                            type="text"
                            class="info-box"
                            placeholder="请选择当前经营业态"
                            readonly
                            v-model="showOptions.parent_manage_type_name + showOptions.son_manage_type_name"
                        />
                        <img src="../../../static/images/publish/go.png" alt class="go" />
                    </div>
                </div>
            </div>
            <div class="form-info desc">
                <div class="form-item text" style="border-bottom:none;">
                    <div class="item-tip">更多要求</div>
                    <div class="textarea-wrapper">
                        <div class="content">{{params.more}}</div>
                        <textarea
                            class="project-tip txt"
                            placeholder="请输入描述"
                            maxlength="300"
                            v-model="params.more"
                        ></textarea>
                    </div>
                </div>
            </div>
        </div>
        <div class="none"></div>
        <div class="btn" @click="publishNeed" v-show="flag" :class="{'active-btn':iosnav}">
            <div class="submit">提交发布</div>
        </div>
        <mt-popup v-model="popupVisible" position="bottom">
            <!-- 商圈选择 -->
            <div class="shopType" v-show="optionsType == 'areaType'">
                <div class="popup-title display_flex">
                    <span>(城区)</span>
                    <span>(商圈)</span>
                </div>
                <div class="option-box display_flex">
                    <ul class="options">
                        <li
                            class="option-item payOption"
                            v-for="item in options.areas"
                            @click="changeOption(item.id,item.name,1,item.childList)"
                            :class="{'left-active':item.id == params.area_id}"
                        >{{item.name}}</li>
                    </ul>
                    <ul class="options">
                        <li
                            class="option-item"
                            v-for="item in showOptions.areaChilds"
                            @click="changeOption(item.childId,item.childName,2)"
                            :class="{'item-active':params.business_area_id.indexOf(item.childId) != '-1' }"
                        >{{item.childName}}</li>
                    </ul>
                </div>
            </div>
            <!-- 商铺类型 -->
            <div class="shopType" v-show="optionsType == 'type'">
                <div class="popup-title">(商业类型)</div>
                <div class="option-box">
                    <ul class="options">
                        <li
                            class="option-item"
                            v-for="item in options.type"
                            @click="changeOption(item.id,item.name)"
                            :class="{'item-active':params.type.indexOf(item.id) != '-1' }"
                        >{{item.name}}</li>
                    </ul>
                </div>
            </div>
            <!-- 经营业态 -->
            <div class="shopType" v-show="optionsType == 'formatType'">
                <div class="popup-title">(计划经营)</div>
                <div class="option-box display_flex">
                    <ul class="options">
                        <li
                            class="option-item payOption"
                            v-for="item in options.shopBusinessTypes"
                            @click="changeOption(item.id,item.name,1,item.childList)"
                            :class="{'left-active':item.id == params.parent_manage_type_id}"
                        >{{item.name}}</li>
                    </ul>
                    <ul class="options">
                        <li
                            class="option-item"
                            v-for="item in showOptions.manageChilds"
                            @click="changeOption(item.childId,item.childName,2)"
                            :class="{'item-active':item.childId == params.son_manage_type_id}"
                        >{{item.childName}}</li>
                    </ul>
                </div>
            </div>
        </mt-popup>
    </div>
</template>
<script>
import { Toast, Indicator } from "mint-ui";
export default {
  data() {
    return {
      active: "",
      popupVisible: false,
      options: "",
      optionsType: "",
      iosnav: false,
      flag: true,
      showOptions: {
        type_name: [],
        parent_manage_type_name: "",
        areaName: "",
        areaId: "",
        business_area_name: [],
        manageChilds: "",
        son_manage_type_name: ""
      },
      params: {
        phone: "",
        cityId: "",
        type: [],
        parent_manage_type_id: "",
        business_area_id: [],
        area_lower: "",
        area_upper: "",
        monthly_rent_lower: "",
        monthly_rent_upper: "",
        more: "",
        area_id: "",
        son_manage_type_id: ""
      }
    };
  },
  mounted() {
    // iPhone X、iPhone XS
    var isIPhoneX =
      /iphone/gi.test(window.navigator.userAgent) &&
      window.devicePixelRatio &&
      window.devicePixelRatio === 3 &&
      window.screen.width === 375 &&
      window.screen.height === 812;
    // iPhone XS Max
    var isIPhoneXSMax =
      /iphone/gi.test(window.navigator.userAgent) &&
      window.devicePixelRatio &&
      window.devicePixelRatio === 3 &&
      window.screen.width === 414 &&
      window.screen.height === 896;
    // iPhone XR
    var isIPhoneXR =
      /iphone/gi.test(window.navigator.userAgent) &&
      window.devicePixelRatio &&
      window.devicePixelRatio === 2 &&
      window.screen.width === 414 &&
      window.screen.height === 896;
    if (this.$route.query.app == "ios") {
      // if (isIPhoneX || isIPhoneXSMax || isIPhoneXR) {
        this.iosnav = true;
      // }
      this.params.phone = this.$route.query.paramPhone;
      this.params.cityId = this.$route.query.cityId;
    } else if (this.$route.query.app == "android") {
      this.iosnav = true;
      this.params.phone = this.$route.query.paramPhone;
      this.params.cityId = this.$route.query.cityId;
    } else {
      this.params.phone = localStorage.iphone;
      this.params.cityId = sessionStorage.cityId || 110100;
    }
    this.getOption();
    if (this.$route.query.app == "ios") {
      window.addEventListener("focusin", () => {
        // 键盘弹出事件处理
        this.flag = false;
      });
      window.addEventListener("focusout", () => {
        // 键盘收起事件处理
        this.flag = true;
      });
    } else if (this.$route.query.app == "android") {
      const innerHeight = window.innerHeight;
      window.addEventListener("resize", () => {
        const newInnerHeight = window.innerHeight;
        if (innerHeight > newInnerHeight) {
          this.flag = false;
        } else {
          // 键盘收起事件处理
          this.flag = true;
        }
      });
    }
  },
  methods: {
    goback() {
      Indicator.close();
      if (this.$route.query.page == "index") {
        if (this.$route.query.app == "ios") {
          //ios交互的返回方法
          window.webkit.messageHandlers.currentCookiesBack.postMessage({
            body: "buttonActionMessage"
          });
        }
        if (this.$route.query.app == "android") {
          //android返回方法
          AndroidDial.showToast("1");
        }
      } else {
        this.$router.go(-1);
      }
    },
    getOption() {
      this.$http({
        url: this.changeData() + "/receive/getNeedShopJson",
        method: "POST",
        params: {
          cityId: this.params.cityId
        }
      }).then(res => {
        if (res.data.code == "101") {
          this.options = res.data.data;
          this.params.area_id = res.data.data.areas[0].id;
          this.showOptions.areaChilds = res.data.data.areas[0].childList;
          this.params.parent_manage_type_id =
            res.data.data.shopBusinessTypes[1].id;
          this.showOptions.manageChilds =
            res.data.data.shopBusinessTypes[1].childList;
        }
      });
    },
    showPopup(showType) {
      this.popupVisible = true;
      this.optionsType = showType;
      if (showType == "areaType" && !this.showOptions.areaName) {
        this.showOptions.areaName = this.options.areas[0].name + " · ";
      }
      if (
        showType == "formatType" &&
        !this.showOptions.parent_manage_type_name
      ) {
        this.showOptions.parent_manage_type_name =
          this.options.shopBusinessTypes[1].name + " · ";
      }
    },
    focus(type) {
      this.active = type;
    },
    blur() {
      this.active = "";
    },
    changeOption(id, name, type, childs) {
      switch (this.optionsType) {
        case "type":
          if (this.params.type.indexOf(id) == "-1") {
            this.showOptions.type_name.push(name);
            this.params.type.push(id);
          } else {
            this.params.type.splice(this.params.type.indexOf(id), 1);
            this.showOptions.type_name.splice(
              this.showOptions.type_name.indexOf(name),
              1
            );
          }
          break;
        case "areaType":
          if (type == 1) {
            this.showOptions.areaId = id;
            this.params.area_id = id;
            this.showOptions.areaName = name + " · ";
            this.showOptions.areaChilds = childs;
            this.showOptions.business_area_name = [];
            this.params.business_area_id = [];
          } else if (type == 2) {
            if (this.params.business_area_id.indexOf(id) == "-1") {
              this.showOptions.business_area_name.push(name);
              this.params.business_area_id.push(id);
            } else {
              this.params.business_area_id.splice(
                this.params.business_area_id.indexOf(id),
                1
              );
              this.showOptions.business_area_name.splice(
                this.showOptions.business_area_name.indexOf(name),
                1
              );
            }
          }
          break;
        case "formatType":
          if (type == 1) {
            this.showOptions.parent_manage_type_name = name + " · ";
            this.params.parent_manage_type_id = id;
            this.showOptions.manageChilds = childs;
            this.params.son_manage_type_id = "";
            this.showOptions.son_manage_type_name = "";
          } else if (type == 2) {
            this.params.son_manage_type_id = id;
            this.showOptions.son_manage_type_name = name;
            this.popupVisible = false;
          }
          break;
      }
    },
    publishNeed() {
      if (this.params.business_area_id.length == 0) {
        Toast("请选择目标区域");
        return;
      }
      if (!this.params.monthly_rent_lower) {
        Toast("请输入月租金");
        return;
      }
      if (+this.params.monthly_rent_lower > 9999999) {
        Toast("最低月租金不得大于9999999");
        return;
      }
      if (+this.params.monthly_rent_upper > 9999999) {
        Toast("最高月租金不得大于9999999");
        return;
      }
      if (+this.params.monthly_rent_lower >= +this.params.monthly_rent_upper) {
        Toast("最高月租金要大于最低月租金");
        return;
      }

      if (!this.params.area_lower) {
        Toast("请输入面积");
        return;
      }
      if (+this.params.area_lower > 99999) {
        Toast("最小面积不得大于99999");
        return;
      }
      if (+this.params.area_upper > 99999) {
        Toast("最大面积不得大于99999");
        return;
      }
      if (+this.params.area_lower >= +this.params.area_upper) {
        Toast("最大面积要大于最小面积");
        return;
      }

      if (this.params.type.length == 0) {
        Toast("请选择商铺类型");
        return;
      }
      if (!this.params.son_manage_type_id) {
        Toast("请选择经营业态");
        return;
      }
      if (!this.params.more) {
        Toast("请输入其他要求");
        return;
      }
      this.$http({
        url: this.changeData() + "/receive/needShop",
        method: "POST",
        params: {
          phone: this.params.phone,
          cityId: this.params.cityId,
          type: this.params.type.join(","),
          parent_manage_type_id: this.params.parent_manage_type_id,
          son_manage_type_id: this.params.son_manage_type_id,
          business_area_id: this.params.business_area_id.join(","),
          area_lower: this.params.area_lower,
          area_upper: this.params.area_upper,
          monthly_rent_lower: this.params.monthly_rent_lower,
          monthly_rent_upper: this.params.monthly_rent_upper,
          more: this.params.more,
          area_id: this.params.area_id,
          userId: this.$route.query.userId
        }
      }).then(res => {
        if (res.data.code == "101") {
          if (this.$route.query.app == "ios") {
            this.$router.push({
              path: "/zhaopudetail",
              query: {
                shopId: res.data.id,
                userId: this.$route.query.userId,
                cityId: this.$route.query.cityId,
                paramPhone: this.$route.query.paramPhone,
                app: "ios"
              }
            });
          } else if (this.$route.query.app == "android") {
            this.$router.push({
              path: "/zhaopudetail",
              query: {
                shopId: res.data.id,
                userId: this.$route.query.userId,
                cityId: this.$route.query.cityId,
                paramPhone: this.$route.query.paramPhone,
                app: "android"
              }
            });
          }
        } else {
          Toast(res.data.message);
        }
      });
    },
    inquiry() {
      if (this.$route.query.app == "ios") {
        window.webkit.messageHandlers.currentCookies.postMessage({
          body: "buttonActionMessage"
        });
      } else if (this.$route.query.app == "android") {
        AndroidDial.showToast("2");
      }
    }
  }
};
</script>
<style lang="scss" scoped>
@import "../../../static/css/publishop.scss";
</style>



// WEBPACK FOOTER //
// src/components/publish/publishneed.vue